import { GET_TOKEN, GUEST_SIGN_IN, REPLACE_GUEST } from '../../../axios/appiendPoints';
import { axiosInstanceNext } from '../../../axios/axios';

export const tokenHttp = (phoneNo, dialCode, otpState, cartToken, skipVal, otp_less_token) => {
  let params = new URLSearchParams();
  params.append('idtoken', '');
  params.append('phone_no', phoneNo);
  params.append('dial_code', ` ${dialCode}`);
  params.append('otp', otpState);
  params.append('cart_token', cartToken);
  params.append('platform', 'web');
  params.append('skip', skipVal);
  params.append('otp_less_token', otp_less_token);
  return axiosInstanceNext.post(GET_TOKEN, params);
};

export const generateGuestToken = () => {
  return axiosInstanceNext.post(GUEST_SIGN_IN);
};
export const replaceGuest = (guest_user_id, actual_user_id) => {
  let params = new URLSearchParams();
  params.append('guest_user_id', guest_user_id);
  params.append('actual_user_id', actual_user_id);
  return axiosInstanceNext.post(REPLACE_GUEST, params);
};
